(function () {
    const MAX_ATTEMPTS = 50;
    let attempts = 0;
    let chatHost;
    let observer;

    function applyChatStyles() {
        if (!chatHost || !chatHost.shadowRoot) return;
        
        // Apply z-index to the main chat host element
        chatHost.style.zIndex = '1000';
        chatHost.style.setProperty('z-index', '1000', 'important');
        
        const chatButton = chatHost.shadowRoot.querySelector('button.chat-toggle');
        const chatTitle = chatButton && chatButton.querySelector('.chat-title');
        const chatSvg = chatButton && chatButton.querySelector('svg');
        
        // Get close button SVG
        const closeButton = chatHost.shadowRoot.querySelector('button.chat-app--close');
        const closeSvg = closeButton && closeButton.querySelector('svg');
        
        if (chatTitle) {
            // Apply font-size of 16px
            chatTitle.style.fontSize = '16px';
            chatTitle.style.setProperty('font-size', '16px', 'important');
        }
        
        if (chatSvg) {
            // Apply height of 36px to the SVG
            chatSvg.style.height = '36px';
            chatSvg.style.setProperty('height', '36px', 'important');
        }
        
        if (closeSvg) {
            // Apply height of 36px to the close button SVG
            closeSvg.style.height = '26px';
            closeSvg.style.setProperty('height', '26px', 'important');
        }
        
        // Log when styles are applied
        if (chatTitle || chatSvg || closeSvg) {
            console.log('Chat button styles applied');
        }
    }

    const isOutsideClick = (event) => {
        const target = event.target;
        return chatHost && !chatHost.contains(target);
    };

    const closeChat = () => {
        if (!chatHost || !chatHost.shadowRoot) return;

        const isOpen = chatHost.getAttribute('is-open') === 'true';
        const closeButton = chatHost.shadowRoot.querySelector('button.chat-app--close-button');

        if (isOpen && closeButton) {
            closeButton.click();
        }
    };

    const setupClickListener = () => {
        document.body.addEventListener('click', (event) => {
            if (isOutsideClick(event)) {
                closeChat();
            }
        });
    };

    const setupObserver = () => {
        if (!chatHost || !chatHost.shadowRoot) return;
        
        // Observe changes in the shadowRoot
        observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'childList') {
                    // Check if the chat button was added
                    const chatButton = chatHost.shadowRoot.querySelector('button.chat-toggle');
                    if (chatButton) {
                        applyChatStyles();
                    }
                }
            });
        });

        observer.observe(chatHost.shadowRoot, {
            childList: true,
            subtree: true
        });
    };

    const trySetup = () => {
        chatHost = document.getElementById('ShopifyChat');
        if (!chatHost || !chatHost.shadowRoot) {
            if (attempts++ < MAX_ATTEMPTS) {
                requestAnimationFrame(trySetup);
            }
            return;
        }

        setupClickListener();
        setupObserver();
        applyChatStyles(); // Apply styles immediately if already exists
    };

    trySetup();
})();
